import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class UnsupportedMediaTypeError extends CodedError {
  static get errorName() {
    return errorCodes.unsupportedMediaTypeError.code;
  }

  constructor(message: string = errorCodes.unsupportedMediaTypeError.message) {
    super(message);
    this.code = errorCodes.unsupportedMediaTypeError.code;
    this.message = `${message} ${errorCodes.unsupportedMediaTypeError.code}`;
    this.name = errorCodes.unsupportedMediaTypeError.name;
  }
}
